export const SETTINGS_STORAGE_KEY = "lotq_user_settings";

export const defaultUserSettings = {
  achievementNotifications: true,
  browserNotifications: true,
  reduceMotion: false,
  highContrast: false,
};

export function readStoredSettings() {
  if (typeof window === "undefined") return { ...defaultUserSettings };
  try {
    const raw = localStorage.getItem(SETTINGS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return { ...defaultUserSettings, ...parsed };
  } catch {
    return { ...defaultUserSettings };
  }
}

export function writeStoredSettings(settings) {
  if (typeof window === "undefined") return;
  const merged = { ...defaultUserSettings, ...settings };
  localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(merged));
}

export function applyUserSettingsToDocument(settings) {
  if (typeof document === "undefined") return;

  const merged = { ...defaultUserSettings, ...settings };
  const root = document.documentElement;
  const body = document.body;

  root.classList.toggle("lotq-reduce-motion", !!merged.reduceMotion);
  body?.classList.toggle("lotq-reduce-motion", !!merged.reduceMotion);

  root.classList.toggle("lotq-high-contrast", !!merged.highContrast);
  body?.classList.toggle("lotq-high-contrast", !!merged.highContrast);
}
